import React from "react";
import ReactDOM from "react-dom/client";
// Temporary: load generated Tailwind build to ensure utilities are present
// import "./_tailwind-build.css";
import "./index.css";
import App from "./app/index.tsx";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
